import { convertMultiSectionInfo } from '@/common/converter/convert-multi-section-info'

/**
 * convert to multi-section (v1) format
 * 홈 데이터(구)를 받아 멀티 섹션 데이터(구) 로 변환
 * @param homeData
 * @returns {{note: string, gen_version: string, multisectionlist: {note: string, bg_color: string, eventlist: Array, icon: string, whitelist: string, force_refresh: string, cell_type: *, title: string, bg_image: string}[], home_version: string, gen_time: string, type: string, version: string}}
 */
export const convertMultiSection = (homeData) => {
  const { description = '', version = '', type = '', layout = {} } = homeData
  const { catalogList = [] } = layout?.catalog

  return {
    note: description,
    type,
    version,
    gen_time: '',
    gen_version: '',
    home_version: '',
    multisectionlist: catalogList.map(convertMultiSectionInfo)
  }
}
